import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../../Config/Config";

export const fetchBatchByCourseIdData = createAsyncThunk(
  "api/batchByCourseId", // Change the action type to something distinct
  async (courseId) => {
    const response = await fetch(
      `${FULL_API_BASE_URL}/get-batch-name-by-course-id/?course_id=${courseId}`
    );
    const data = await response.json();
    return data;
  }
);

const batchByCourseIdSlice = createSlice({
  // Change the slice name to something distinct
  name: "batchByCourseId", // Change the slice name to something distinct
  initialState: {
    batchesDataByCourseId: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatchByCourseIdData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBatchByCourseIdData.fulfilled, (state, action) => {
        state.loading = false;
        state.batchesDataByCourseId = action.payload;
      })
      .addCase(fetchBatchByCourseIdData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default batchByCourseIdSlice.reducer;
